import Header from "../home/header";
import Footer from "../home/footer";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";


const Cart = () => {
  const { cart, removeFromCart, updateQuantity, refreshCart } = useCart();
  
   useEffect(() => {
    refreshCart(); // 🔥 fetch latest cart ONCE when page opens
  }, []);

  const navigate = useNavigate();
    const subtotal = cart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

  const delivery = subtotal > 500 ? 0 : 50;
  const finalTotal = subtotal + delivery;

  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item) => {
        images[item.replace("./", "")] = r(item);
    });
    return images;
  };
  

  const handleCheckout = () => {
    const userEmail = localStorage.getItem("email"); // or session check
    if (!userEmail) {
      alert("Please login first to proceed to checkout");
      navigate("/login"); 
    } else {
      navigate("/checkout"); 
    }
  };

  const productFolders = {
    product:  importAll(require.context("../../assets/product",   false, /\.(png|jpg)$/)),
    product1: importAll(require.context("../../assets/product1",  false, /\.(png|jpg)$/)),
    product2: importAll(require.context("../../assets/product2",  false, /\.(png|jpg)$/)),
    product3: importAll(require.context("../../assets/product3",  false, /\.(png|jpg)$/)),
    product4: importAll(require.context("../../assets/product4",  false, /\.(png|jpg)$/)),
    product5: importAll(require.context("../../assets/product5",  false, /\.(png|jpg)$/)),
    product6: importAll(require.context("../../assets/product6",  false, /\.(png|jpg)$/)),
    product7: importAll(require.context("../../assets/product7",  false, /\.(png|jpg)$/)),
    product8: importAll(require.context("../../assets/product8",  false, /\.(png|jpg)$/)),
    product9: importAll(require.context("../../assets/product9",  false, /\.(png|jpg)$/)),
    product10: importAll(require.context("../../assets/product10", false, /\.(png|jpg)$/)),
    product11: importAll(require.context("../../assets/product11", false, /\.(png|jpg)$/)),
    product12: importAll(require.context("../../assets/product12", false, /\.(png|jpg)$/)),
    product13: importAll(require.context("../../assets/product13", false, /\.(png|jpg)$/)),
    product14: importAll(require.context("../../assets/product14", false, /\.(png|jpg)$/)),
    product15: importAll(require.context("../../assets/product15", false, /\.(png|jpg)$/)),
    product16: importAll(require.context("../../assets/product16", false, /\.(png|jpg)$/)),
    product17: importAll(require.context("../../assets/product17", false, /\.(png|jpg)$/)),
    product18: importAll(require.context("../../assets/product18", false, /\.(png|jpg)$/)),
    product19: importAll(require.context("../../assets/product19", false, /\.(png|jpg)$/)),
    product20: importAll(require.context("../../assets/product20", false, /\.(png|jpg)$/)),
    product21: importAll(require.context("../../assets/product21", false, /\.(png|jpg)$/)),
    // product22: importAll(require.context("../../assets/product22", false, /\.(png|jpg)$/)),
  };

  const getImg = (folder, img) => {
    return productFolders[folder]?.[img] || "";
  };


  return (
    <>
      <Header />

      <div className="container-fluid"> 
        <div className="container">

          <div className="cart-container" style={{
          }}>
            <h2 className="cart-heading">Your Cart</h2>

            {cart.length === 0 ? (
              <div className="empty-cart" style={{
                height:'70vh'
              }}>
                <p>Your cart is empty</p>
                <Link to="/store" className="shop-btn">Shop Now</Link>
              </div>
            ) : (
              <div className="cart-wrapper">

                {/* LEFT SIDE CART ITEMS */}
                <div className="cart-items">
                  {cart.map((item) => (
                    <div className="cart-card" key={item.id}>
                                            
                    <img
                    src={getImg(item.folder, item.image[0])}
                    alt={item.name}
                    className="cart-img"
                    />

                    <div className="cart-info">
                        <h4>{item.name}</h4>
                        <p className="price">₹{item.price}</p>

                        <div className="quantity-box">
                            <button onClick={() => updateQuantity(item.id, item.weight, item.quantity - 1)}>-</button>

                            <span>{item.quantity}</span>

                            <button onClick={() => updateQuantity(item.id, item.weight, item.quantity + 1)}>+</button>

                        </div>

                        <button
                          className="remove-btn"
                          onClick={() => removeFromCart(item.id, item.weight)}
                        >
                          Remove
                        </button>

                    </div>

                      <p className="item-total">
                        ₹{item.price * item.quantity}
                      </p>
                    </div>
                  ))}
                </div>

                {/* RIGHT SIDE SUMMARY */}
                <div className="cart-summary">
                  <h3>Order Summary</h3>

                  <div className="summary-row">
                    <span>Subtotal</span>
                    <span>₹{subtotal}</span>
                  </div>

                  <div className="summary-row">
                    <span>Delivery</span>
                    <span>{delivery === 0 ? "FREE" : `₹${delivery}`}</span>
                  </div>

                  <hr />

                  <div className="summary-total">
                    <span>Total</span>
                    <span>₹{finalTotal}</span>
                  </div>

                  <button className="checkout-btn"
                   onClick={handleCheckout}
                   style={{
                    boxShadow:'5px 5px gray',
                    borderRadius:'30px'
                   }}
                  >
                    Proceed to Checkout
                  </button>

                  <p className="tagline">Eat Healthy, Stay Healthy</p>
                </div>

              </div>
            )}
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default Cart;
